import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	popularity: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	popularity: {
		id: 'directories.filters-v2.main.content.cells.popularity.popularity',
		defaultMessage: '{popularity, plural, one {{popularity} person} other {{popularity} people}}',

		description: 'Displaying filter popularity (favorites count)',
	},
});
export default messages;
